<div>
  <form #df="ngForm" novalidate>
    <div class="table-responsive table-striped mt-4 formborder">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="Id">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let element; let i = index" class="grid-cell">
            {{ i + 1 }}
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="scoreType">
          <th mat-header-cell
              *matHeaderCellDef
              style="text-align: left !important">
            Score Type
          </th>
          <td mat-cell *matCellDef="let element">{{ element.ScoreType }}</td>
          <td mat-footer-cell *matFooterCellDef class="text-center"></td>
        </ng-container>

        <ng-container matColumnDef="values">
          <th mat-header-cell *matHeaderCellDef>Values</th>
          <td mat-cell *matCellDef="let element" class="grid-cell">
            <ng-container>
              <mat-form-field class="full-width" *ngIf="!element.IsDyanamic && isEditing ">
                <mat-select (selectionChange)="onDropdownChange(element)"
                            [(value)]="element.ScoreValue"
                            [disabled]="!isEditing"
                            class="form-control input-text-css"
                            style="position: relative !important; bottom: 12px !important">
                  <!--<mat-option [value]="">Select Values</mat-option>-->
                  <mat-option *ngFor="let option of element.values"
                              [value]="option">
                    {{ option.value }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <span *ngIf="!element.IsDyanamic && !isEditing">{{ element.scoreViewName }}</span>
              <span *ngIf="element.IsDyanamic">{{ element.ScoreValue }}</span>

            </ng-container>
            <!--<ng-template #staticText>{{ element.ScoreValue }}</ng-template>-->
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="Score">
          <th mat-header-cell
              *matHeaderCellDef
              style="text-align: left !important">
            Score
          </th>
          <td mat-cell *matCellDef="let element" class="grid-cell">
            {{ element.FinalScore }}
          </td>
          <td mat-footer-cell *matFooterCellDef class="text-right">
            <strong>{{ totaltypewise("FinalScore") }}</strong>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
      </table>
    </div>

    <div class="row m-0 col-md-12 formborder mt-2"
         style="display: flex; align-items: center">
      <div class="col-md-9 p-1">
        <span class="required-lable"> Remarks </span>
        <textarea [disabled]="!isEditing"
                  required
                  #refRemarks="ngModel"
                  maxlength="500"
                  [(ngModel)]="Remarks"
                  placeholder="Remarks"
                  name="Remarks"
                  id="Remarks"
                  class="form-control input-text-css"></textarea>
      </div>

      <div class="col-md-3">
        <button type="button"
                class="mt-3 btn font-size-12 button-btn"
                (click)="toggleEditMode()"
                *ngIf="
          PageData.currentTab == 1 &&
          Status != 'C' &&
          (Status == 'R' ? (Revert_IsEdit == 1 ? true : false) : true)
        "
                [disabled]="isEditing && !canSave()">
          {{ isEditing ? "Save" : "Edit" }}
        </button>
      </div>
    </div>
    </form>
</div>

<div class="row col-md-12 m-0 mt-2 justify-content-end">
  <button
    type="button"
    (click)="nextPageRedirectFunc()"
    class="btn font-size-12 button-btn"
  >
    Next <i class="fa fa-arrow-right"></i>
  </button>
</div>
